<template>
  <div class="setps__list">
    <h4 data-anim="text">{{ dataList.title }}</h4>
    <ul>
      <li
        v-for="city in dataList.cities"
        :key="city"
        data-anim="text"
      >
        <router-link :to="`/${city}`" v-if="/^(tokyo|berlin|milan|porto|copenhagen)$/.test(city)">
          {{ city }}
        </router-link>
        <span v-else>
          {{ city }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'InfoStepsList',

  props: ['dataList', 'title'],
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.setps__list {
  display: flex;
  align-items: baseline;

  h4 {
    display: inline-block;
    width: 40%;
    margin-right: 40px;

    font-size: 1rem;
    font-weight: 500;
    text-transform: uppercase;
    color: $color-dark-gray;
  }

  a {
    text-transform: capitalize;
    font-weight: 500;
    color: $color-light;
    transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

    @at-root .pointerevents:not(.touchevents) &:hover,
    .no-pointerevents.no-touchevents &:hover {
      color: $color-blue;
    }
  }

  span {
    text-transform: capitalize;
    font-weight: 500;
    color: $color-light;
  }

  ul {
    display: inline-block;
    padding-bottom: 20px;

    @include mq(sm) {
      padding-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoStepsList.vue